import { memo } from "react";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { ThemedCutIcon } from "assets/CXFIcons/Designer/ContextActions";

const ButtonCutNode = ({ cutNode }) => {
  return (
    <Tooltip title={"Cut Node"} placement="bottom">
      <IconButton size="small" style={{ width: "100%", height: "100%" }} onClick={cutNode}>
        <ThemedCutIcon width="16px" height="16px" color="currentColor" />
      </IconButton>
    </Tooltip>
  );
};

export default memo(ButtonCutNode);
